/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { getAnalyticTags } from "core/lib/analytics-methods";
import { PopupContents } from "core/types";
import { CachedBooleanValue } from "@lib-shared/lib";

const interstitialPopupCache = new CachedBooleanValue("storedSelection");

type InterstitialPopupProps = {
  popupContents: PopupContents;
}

const InterstitialPopup = (props: InterstitialPopupProps) => {
  const [rememberSelection, setRememberSelection] = useState(false);

  const { popupContents } = props;

  return (
    <div className="interstitial-popup">
      <div className="row">
        <div className="col-md-6 subscribe">
          <h3 className="pb-2">I want to subscribe</h3>
          <p>No Dish required - Buy now and never miss a moment or let us tell you more about your options</p>
          <a
            type="button"
            className="button popup-btn mb-2 mt-2"
            href="#"
            target="_blank"
            rel="noreferrer"
            {...getAnalyticTags({
              component_name: "show_buy_to_stream",
              component_type: "show_modal",
              cta_text: "Buy to stream",
              show_name: popupContents.showTitle,
              channel_name: popupContents.channelName,
              channel_number: popupContents.channelNumber,
              target_page_url: window.location.href
            })}
            onClick={() => {
              //
            }}
          >
            <span className="text">
              {"Buy to stream"}
            </span>
          </a>
          <a
            type="button"
            className="button popup-btn more-info-btn mb-2 mt-2"
            href="#"
            target="_blank"
            rel="noreferrer"
            {...getAnalyticTags({
              component_name: "show_tell_me_more",
              component_type: "show_modal",
              cta_text: "Tell me more",
              show_name: popupContents.showTitle,
              channel_name: popupContents.channelName,
              channel_number: popupContents.channelNumber,
              target_page_url: window.location.href
            })}
            onClick={() => {
              //
            }}
          >
            <span className="text">
              {"Tell me more"}
            </span>
          </a>
        </div>
        <div className="col-md-6 customer">
          <h3 className="pb-2">I am a customer</h3>
          <p>Choose how you want to watch</p>
          <a
            type="button"
            className="button popup-btn mb-2 mt-2"
            href={`${popupContents.link.dstvNow}`}
            target="_blank"
            rel="noreferrer"
            {...getAnalyticTags({
              component_name: "show_watch_now",
              component_type: "show_modal",
              cta_text: "Watch on Dstv",
              show_name: popupContents.showTitle,
              channel_name: popupContents.channelName,
              channel_number: popupContents.channelNumber,
              target_page_url: `${popupContents.link.dstvNow}`
            })}
            onClick={() => {
              //
            }}
          >
            <span className="text">
              {"Watch on Dstv"}
            </span>
          </a>

          <div className="input-holder">
            <label
              htmlFor="selection"
              className="compact-checkbox mb-3 mt-2"
            >
              <input
                type="checkbox"
                id="selection"
                name="compact"
                value={rememberSelection.toString()}
                onClick={() => {
                  if (rememberSelection) {
                    interstitialPopupCache.clear();
                    setRememberSelection(!rememberSelection);
                    return
                  }

                  interstitialPopupCache.set(!rememberSelection);
                  setRememberSelection(!rememberSelection);
                }}
              ></input>
              <span className="custom-checkbox"></span>
              {"Remember my selection"}
            </label>
            <p className="mb-0 mt-2">Need to upgrade or Reconnect?</p>
            <a href="#" className="">Manage your account</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterstitialPopup;
